import {useNavigate} from "react-router-dom";
import React from "react";

const ComingSoon = () => {
    const navigate = useNavigate();
    const handleBack = () => navigate(-1);

    return (
        <section
            className="form5 cid-comingsoon cid-uGVx9CHyO3"
            id="coming-soon-section"
            style={{
                paddingTop : "150px" ,
                display : "flex" ,
                flexDirection : "column" ,
                justifyContent : "center" ,
                alignItems : "center" ,
                minHeight : "100vh" ,
                textAlign : "center"
            }}
        >
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-12 content-head">
                        <h3 className="mbr-section-title
                                mbr-fonts-style text-primary mb-3 display-2">
                            <strong>Скоро появится</strong>
                        </h3>
                        <p className="mbr-fonts-style lead">
                            Мы работаем над этой страницей. Загляните позже!
                        </p>
                        <div className="d-flex justify-content-center mt-4 gap-3">
                            <button className="btn btn-info" onClick={handleBack}>Вернуться</button>
                            <a href="/src/static" className="btn btn-info">На главную</a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

ComingSoon.link = "/coming-soon";

export default ComingSoon;